import { useState, useEffect, useCallback, useMemo } from "react";
import store from "redux/store";
import { useDispatch, useSelector } from "react-redux";

//translation files
import PL from "./pl";
import EN from "./en";

const Translate = ({ component, Tkey: key }) => {
	let currLang = store.getState().lang;
	let text;
	store.subscribe(() => {
		currLang = store.getState().lang;
	});

	if (currLang === "PL") {
		text = PL[component][key];
	} else if (currLang === "EN") {
		text = EN[component][key];
	}

	return text;
};

const useTranslate = ({ component, Tkey: key }) => {
	const currLang = useSelector(state => state.lang);
	const [text, setText] = useState("");

	const updateText = useCallback(() => {
		if (!component || !key) return;

		if (currLang === "PL") {
			setText(PL[component][key]);
		} else if (currLang === "EN") {
			setText(EN[component][key]);
		}
	}, [currLang, component, key]);

	useEffect(() => {
		updateText();
		return () => {};
	}, [currLang, updateText]);

	return text;
};

const useTranslateFunction = c => {
	const currLang = useSelector(state => state.lang);
	const memorisedFunction = useMemo(
		() => (key, component = c) => {
			if (!component || !key) return;

			let translationResult;
			switch (currLang) {
				case "PL":
					translationResult = PL[component][key];
					break;
				default:
					// Default is english
					translationResult = EN[component][key];
					break;
			}

			if (!translationResult) {
				console.warn(`No translation found for ${currLang}[${component}][${key}]`);
				return `${currLang}(${key})`;
			}

			return translationResult;
		},
		[currLang, c]
	);

	return memorisedFunction;
};

function useLanguage() {
	const currLang = useSelector(state => state.lang);
	return currLang;
}

const useSetLanguage = lang => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch({ type: "LANGUAGE_SET", state: lang });
	});
};

export default Translate;
export { Translate, useTranslate, useLanguage, useSetLanguage, useTranslateFunction };
